<template>
    <div class="menu">
        <div class="logo"><img src="@/assets/images/logo.png" v-bind="logoAttrs"></div>
        <nav>
            <ul>
                <li v-for="(menu, key) in menu" :key="key">
                    <router-link :active-class="active" :to="{ name: menu.link }">{{ menu.text }}</router-link>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
    "use strict";

    export default {
        data() {
            return {
                "active": "is-current",
                "logoAttrs": {
                    "alt": "管クリ",
                    "title": "管クリ",
                },
                "menu": {
                    "register": {
                        "link": "offices_delivery_destinations",
                        "text": "登録",
                    },
                    "search": {
                        "link": "offices_delivery_destinations_search",
                        "text": "検索",
                    },
                    "delivery_allocation": {
                        "link": "offices_delivery_allocations",
                        "text": "配車",
                    },
                    "delivery_allocation_list": {
                        "link": "offices_delivery_allocations_list",
                        "text": "配車一覧",
                    },
                    "work_times": {
                        "link": "offices_work_times_list",
                        "text": "出社時間変更",
                    },
                    "daily_report": {
                        "link": "offices_daily_reports_list",
                        "text": "運転日報",
                    },
                    "vehicle_inspections": {
                        "link": "offices_vehicle_inspections_list",
                        "text": "車両点検",
                    },
                    "driver": {
                        "link": "offices_drivers_list",
                        "text": "ドライバー管理",
                    },
                    "vehicle": {
                        "link": "offices_vehicles_list",
                        "text": "車両管理",
                    },
                },
            };
        },
    };
</script>
